import "./Alert.css"

function Alert({ title, description, className, variant = "default", ...props }) {
  const variantClass = variant === "destructive" ? "alert-destructive" : "alert-default"

  return (
    <div className={`alert ${variantClass} ${className || ""}`} {...props}>
      {title && <h5 className="alert-title">{title}</h5>}
      {description && <div className="alert-description">{description}</div>}
    </div>
  )
}

export default Alert

